import FullScreenAlert from "@/components/raytd/full-screen-alert";
import { AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface AccessDeniedProps {
  message?: string;
  onBack?: () => void;
  backLabel?: string;
}

/**
 * Full-screen Access Denied component displayed when user lacks permissions (403)
 */
export function AccessDenied({ 
  message = "You do not have permission to access this resource.",
  onBack,
  backLabel = "Go Back"
}: AccessDeniedProps) {
  return (
    <FullScreenAlert
      
      buttons={
        onBack && (
          <Button variant="outline" onClick={onBack}>
            {backLabel}
          </Button>
        )
      }>
      <AlertTitle className="text-lg font-medium mb-2">
        No Access
      </AlertTitle>
      <AlertDescription>
        {message}
      </AlertDescription>
    </FullScreenAlert>
  );
}

